import { AVAILABILITY_TABLE } from 'constants/db.contants'
import { supabase } from 'utils/supabase'
import ApiService from './ApiService'

export const apiGetMediationSchedule = async (
    mediator_id,
    startOfMonth,
    endOfMonth,
    appliedCouponCodeId
) => {
    const query = supabase
        .from(AVAILABILITY_TABLE)
        .select(`*, cases (*)`)
        .eq('mediator_id', mediator_id)
        .gte('date', startOfMonth)
        .lte('date', endOfMonth)
        .order('date', { ascending: true })

    if (appliedCouponCodeId) {
        query.filter('couponCodes', 'cs', `[{"id": ${appliedCouponCodeId}}]`)
    }

    const { data, error } = await query
    return { data, error }
}
export const apiFullDayTimeSlot = async (mediator_id) => {
    const { data, error } = await supabase
        .from('mediators')
        .select(`fullday_time`)
        .eq('user_id', mediator_id)
        .single()

    return { data, error }
}

export async function apiUpdateSlotCouponsCode({
    slotUuid,
    mediationId,
    updateRecord,
}) {
    const { data, error } = await supabase
        .from(AVAILABILITY_TABLE)
        .update(updateRecord)
        .match({ uuid: slotUuid, mediator_id: mediationId })
        .select()
    if (error) throw error
    return data
}

export async function apiUpdateMediationSchedule(payload) {
    const {
        date,
        slot,
        status,
        mediator_id,
        slot_time,
        is_available_by_mediator,
        couponCodes,
        proceeded_at,
    } = payload

    const dataToUpsert = {
        date,
        slot,
        status,
        mediator_id,
        slot_time,
        is_available_by_mediator,
        proceeded_at,
    }

    if (couponCodes !== undefined) {
        Object.assign(dataToUpsert, {
            couponCodes,
        })
    }

    return await supabase.from(AVAILABILITY_TABLE).upsert([dataToUpsert], {
        onConflict: ['date', 'slot', 'mediator_id'],
    })
}

/** Bulk upsert (e.g. Open Monthly Availability) — one HTTP call to backend */
export async function apiBulkUpsertMediationSchedule(payload) {
    return ApiService.fetchData({
        url: 'portal/bulk-update-mediation-schedule',
        method: 'put',
        data: payload,
    })
}

export async function apiGetScheduleDetails(
    date,
    mediator_id,
    couponId
) {
    const query = supabase
        .from(AVAILABILITY_TABLE)
        .select('*')
        .eq('mediator_id', mediator_id)
        .eq('date', date)

    if (couponId != null && couponId !== '') {
        query.filter('couponCodes', 'cs', `[{"id": ${Number(couponId)}}]`)
    }

    const { data, error } = await query
    return { data, error }
}

export async function updateMediatorSchedule(
    date,
    mediatorId,
    status,
    slot,
    scheduled_case_id
) {
    return await supabase.from(AVAILABILITY_TABLE).upsert(
        [
            {
                date,
                mediator_id: mediatorId,
                status,
                slot,
                scheduled_case_id,
            },
        ],
        {
            onConflict: ['date', 'mediator_id', 'slot'],
        }
    )
}

export const updateAvailityStatus = async (ids, status, caseid) => {
    const { data, error } = await supabase
        .from(AVAILABILITY_TABLE)
        .update({ status, case_id: caseid })
        .in('id', ids)
        .select()
    if (error) throw error
    return data
}
